// extracted by mini-css-extract-plugin
module.exports = {"Duration":"Duration--2zU5O","Empty":"Empty--2GVUi","Wrapper":"Wrapper--2Uihd"};